import { Skeleton } from '@picsart/design-system/components/Skeleton';
import useStyles from './styles';

const FontListSkeleton = ({ landingsDataCount }: { landingsDataCount: number }) => {
  const styles = useStyles();
  const BASE_COUNT = 60;
  const skeletonCount = Math.max(landingsDataCount || 0, 0) + BASE_COUNT;
  return (
    <div className={styles.root} data-testid="font-skeleton">
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <Skeleton key={index} className={styles.skeletonBlock} />
      ))}
    </div>
  );
};

export default FontListSkeleton;
